import React from 'react';

export const VerificationCodeScreen = ({
  phoneNumber,
  verificationCode,
  onChange,
  onVerify,
  error,
  isLoading,
  businessLogo,
  getErrorMessage
}) => {
  return (
    <div className="min-h-screen bg-white relative flex items-center justify-center">
      <div className="max-w-md mx-auto w-full px-4">
        <div className="bg-gradient-to-br from-rose-50 via-pink-50 to-purple-50 backdrop-blur-sm border border-white/20 rounded-3xl p-8 shadow-2xl">
          <div className="text-center mb-8">
            <h1 className="text-2xl font-bold text-gray-900 mb-2">אימות טלפון</h1>
            <p className="text-gray-600">נשלח קוד אימות לטלפון {phoneNumber}</p>
            <p className="text-gray-600 text-sm mt-2">אנא הזינו את הקוד בן 5 הספרות</p>
          </div>

          <div className="space-y-4">
            <div>
              <label htmlFor="verificationCode" className="block text-sm font-medium text-gray-700 mb-2">
                קוד אימות
              </label>
              <input
                id="verificationCode"
                type="text"
                value={verificationCode}
                onChange={onChange}
                placeholder="הזינו קוד בן 5 ספרות"
                className={`w-full px-4 py-3 bg-white/60 backdrop-blur-sm border rounded-2xl focus:outline-none focus:ring-2 focus:ring-rose-500 focus:border-transparent transition-all duration-300 text-center text-xl tracking-widest ${
                  error ? 'border-red-300 ring-2 ring-red-200' : 'border-white/30'
                }`}
                maxLength="5"
              />
              {error && (
                <p className="text-red-500 text-sm mt-2">
                  {getErrorMessage ? getErrorMessage(error) : error}
                </p>
              )}
            </div>

            <button
              onClick={onVerify}
              disabled={verificationCode.length !== 5 || isLoading}
              className="w-full bg-gradient-to-r from-rose-500 to-pink-500 text-white py-3 rounded-2xl font-semibold hover:shadow-lg transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isLoading ? 'מאמת...' : 'אמת קוד'}
            </button>
          </div>
        </div>

        {/* Business Logo - Below the card */}
        {businessLogo && (
          <div className="w-full py-6 flex justify-center">
            <img
              src={businessLogo}
              alt="Business Logo"
              className="h-16 w-auto object-contain"
            />
          </div>
        )}
      </div>
    </div>
  );
};
